import { render, staticRenderFns } from "./SelectLocaleNew.vue?vue&type=template&id=c217e9e8&scoped=true&"
import script from "./SelectLocaleNew.vue?vue&type=script&lang=ts&"
export * from "./SelectLocaleNew.vue?vue&type=script&lang=ts&"
import style0 from "./SelectLocaleNew.vue?vue&type=style&index=0&id=c217e9e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c217e9e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemContent,VListItemGroup})
